export const optionPie = {
  tooltip: {
    trigger: 'item'
  },
  legend: {
    orient: 'vertical',
    left: 'left',
    textStyle: {
      fontSize: 18
    }
  },
  color: ['#2D2B74', '#86D4B5'],
  series: [
    {
      name: 'TBD',
      type: 'pie',
      radius: '80%',
      data: [
        { value: Math.floor(Math.random() * 101), name: 'TBD' },
        { value: Math.floor(Math.random() * 101), name: 'TBD2' }
      ],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  ]
}
